import type { MatchData } from "./types";

// ==================================================
// MEN'S DOMESTIC MATCHES 2026/27
// INVESTEC CHAMPIONS CUP
// ==================================================

export const matches2026Investec: MatchData[] = [
  {
    id: 9101,
    matchKey: "gloucester-vs-bordeaux-begles-investec",
    competitionId: "champions-cup",
    tournamentInstanceId: "champions-cup-2027",
    tournament: "Investec Champions Cup 2026/27",
    gender: "men",
    round: "Round 1",
    date: "2026-10-16",
    venue: "Kingsholm Stadium, Gloucester",
    home: { name: "Gloucester Rugby", country: "investec-gloucester" },
    away: {
      name: "Union Bordeaux Bègles",
      country: "investec-bordeaux-begles",
    },
   score: { home: 36, away: 36 },
  state: "final",
  startTime: "21:00",
  },
  {
    id: 9102,
    matchKey: "sale-vs-glasgow-investec",
    competitionId: "champions-cup",
    tournamentInstanceId: "champions-cup-2027",
    tournament: "Investec Champions Cup 2026/27",
    gender: "men",
    round: "Round 1",
    date: "2026-10-17",
    venue: "CorpAcq Stadium, Salford",
    home: { name: "Sale Sharks", country: "investec-sale" },
    away: { name: "Glasgow Warriors", country: "investec-glasgow" },
    score: { home: 27, away: 47 },
  state: "final",
  startTime: "14:00",
  },
  {
    id: 9103,
    matchKey: "bulls-vs-stade-francais-investec",
    competitionId: "champions-cup",
    tournamentInstanceId: "champions-cup-2027",
    tournament: "Investec Champions Cup 2026/27",
    gender: "men",
    round: "Round 1",
    date: "2026-10-17",
    venue: "Loftus Versfeld, Pretoria",
    home: { name: "Vodacom Bulls", country: "investec-bulls" },
    away: {
      name: "Stade Français Paris",
      country: "investec-stade-francais",
    },
    score: { home: 56, away: 20 },
  state: "final",
  startTime: "14:00",
  },
  {
    id: 9104,
    matchKey: "clermont-vs-leinster-investec",
    competitionId: "champions-cup",
    tournamentInstanceId: "champions-cup-2027",
    tournament: "Investec Champions Cup 2026/27",
    gender: "men",
    round: "Round 1",
    date: "2026-10-17",
    venue: "Stade Marcel-Michelin, Clermont-Ferrand",
    home: { name: "ASM Clermont Auvergne", country: "investec-clermont" },
    away: { name: "Leinster Rugby", country: "investec-leinster" },
    score: { home: 23, away: 48 },
  state: "final",
  startTime: "16:15",
  },
  {
    id: 9105,
    matchKey: "stormers-vs-bristol-investec",
    competitionId: "champions-cup",
    tournamentInstanceId: "champions-cup-2027",
    tournament: "Investec Champions Cup 2026/27",
    gender: "men",
    round: "Round 1",
    date: "2026-10-17",
    venue: "DHL Stadium, Cape Town",
    home: { name: "DHL Stormers", country: "investec-stormers" },
    away: { name: "Bristol Bears", country: "investec-bristol" },
    score: { home: 49, away: 12 },
  state: "final",
  startTime: "16:15",
  },
  {
    id: 9106,
    matchKey: "connacht-vs-saracens-investec",
    competitionId: "champions-cup",
    tournamentInstanceId: "champions-cup-2027",
    tournament: "Investec Champions Cup 2026/27",
    gender: "men",
    round: "Round 1",
    date: "2026-10-17",
    venue: "Dexcom Stadium, Galway",
    home: { name: "Connacht Rugby", country: "investec-connacht" },
    away: { name: "Saracens", country: "investec-saracens" },
  score: { home: 45, away: 36 },
  state: "final",
  startTime: "18:30",
  },
  {
    id: 9107,
    matchKey: "la-rochelle-vs-lions-investec",
    competitionId: "champions-cup",
    tournamentInstanceId: "champions-cup-2027",
    tournament: "Investec Champions Cup 2026/27",
    gender: "men",
    round: "Round 1",
    date: "2026-10-17",
    venue: "Stade Marcel Deflandre, La Rochelle",
    home: { name: "Stade Rochelais", country: "investec-la-rochelle" },
    away: { name: "10bet Lions", country: "investec-lions" },
   score: { home: 31, away: 14 },
  state: "final",
  startTime: "18:30",
  },
  {
    id: 9108,
    matchKey: "munster-vs-racing-92-investec",
    competitionId: "champions-cup",
    tournamentInstanceId: "champions-cup-2027",
    tournament: "Investec Champions Cup 2026/27",
    gender: "men",
    round: "Round 1",
    date: "2026-10-17",
    venue: "SuperValu Páirc Uí Chaoimh, Cork",
    home: { name: "Munster Rugby", country: "investec-munster" },
    away: { name: "Racing 92", country: "investec-racing-92" },
    score: { home: 33, away: 25 },
  state: "final",
  startTime: "21:00",
  },
  {
    id: 9109,
    matchKey: "bath-vs-montpellier-investec",
    competitionId: "champions-cup",
    tournamentInstanceId: "champions-cup-2027",
    tournament: "Investec Champions Cup 2026/27",
    gender: "men",
    round: "Round 1",
    date: "2026-10-17",
    venue: "The Rec, Bath",
    home: { name: "Bath Rugby", country: "investec-bath" },
    away: {
      name: "Montpellier Hérault Rugby",
      country: "investec-montpellier",
    },
    score: { home: 14, away: 32 },
  state: "final",
  startTime: "21:00",
  },
  {
    id: 9110,
    matchKey: "pau-vs-leicester-investec",
    competitionId: "champions-cup",
    tournamentInstanceId: "champions-cup-2027",
    tournament: "Investec Champions Cup 2026/27",
    gender: "men",
    round: "Round 1",
    date: "2026-10-18",
    venue: "Stade du Hameau, Pau",
    home: { name: "Section Paloise", country: "investec-pau" },
    away: { name: "Leicester Tigers", country: "investec-leicester" },
    state: "upcoming",
    startTime: "12:00",
  },
  {
    id: 9111,
    matchKey: "toulouse-vs-exeter-investec",
    competitionId: "champions-cup",
    tournamentInstanceId: "champions-cup-2027",
    tournament: "Investec Champions Cup 2026/27",
    gender: "men",
    round: "Round 1",
    date: "2026-10-18",
    venue: "Stadium de Toulouse, Toulouse",
    home: { name: "Stade Toulousain", country: "investec-toulouse" },
    away: { name: "Exeter Chiefs", country: "investec-exeter" },
    score: { home: 43, away: 40 },
  state: "final",
  startTime: "14:15",
  },
  {
    id: 9112,
    matchKey: "northampton-vs-cardiff-investec",
    competitionId: "champions-cup",
    tournamentInstanceId: "champions-cup-2027",
    tournament: "Investec Champions Cup 2026/27",
    gender: "men",
    round: "Round 1",
    date: "2026-10-18",
    venue: "DPD Stadium at Franklin's Gardens, Northampton",
    home: { name: "Northampton Saints", country: "investec-northampton" },
    away: { name: "Cardiff Rugby", country: "investec-cardiff" },
    score: { home: 28, away: 12 },
  state: "final",
  startTime: "16:30",
  },
];